import React from "react";
import {
    Grid,
    Box,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import InstallDialogAction from "./InstallDialogAction";

const imageStyle = {
    width: "100%",
    height: "auto",
};

const InstallDialog = (props) => {
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="dialog-title"
        >
            <DialogTitle
                id="dialog-title"
                variant="h1"
                style={{
                    fontSize: 24,
                    fontFamily: '"CeraPro",sans-serif',
                    fontWeight: 700,
                    marginTop: "1rem",
                }}
            >
                <Box
                    style={{
                        "&::after": {
                            content: "''",
                            display: "block",
                            width: "1.5em",
                            height: "0.1em",
                            margin: "0 0.07em 0.3em",
                            backgroundColor: "black",
                        },
                    }}
                >
                    Zum Homescreen hinzufügen
                    {props.onClose ? (
                        <IconButton
                            aria-label="close"
                            onClick={props.onClose}
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </Box>
            </DialogTitle>
            <DialogContent dividers={true}>
                <Grid container alignItems="center" style={{ height: "100%" }}>
                    <Grid item>
                        <Box>
                            <Typography variant="body2" component="div">
                                Jetzt schnell und einfach checken, ob HD+ im
                                Fernseher integriert ist.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogContent>
                <InstallDialogAction
                    platform={props.platform}
                    onSubmit={props.onSubmit}
                    onClose={props.onClose}
                    instructionTitle={props.instructionTitle}
                    instructionActionOk={props.instructionActionOk}
                    instructionActionCancel={props.instructionActionCancel}
                    instructionActionInstall={props.instructionActionInstall}
                    instructionIdeviceAction1={
                        <>
                            <Box
                                component="img"
                                src="Step-1-img-ios.png"
                                style={imageStyle}
                            ></Box>
                        </>
                    }
                    instructionIdeviceAction2={
                        <>
                            <Box
                                component="img"
                                src="Step-2-img-ios.png"
                                style={imageStyle}
                            ></Box>
                        </>
                    }
                    instructionIdeviceAction3={
                        <>
                            <Box
                                component="img"
                                src="Step-3-img-ios.png"
                                style={imageStyle}
                            ></Box>
                        </>
                    }
                    instructionNativeAction1={
                        <>
                            <Box
                                component="img"
                                src="Step-1-img-android.png"
                                style={imageStyle}
                            ></Box>
                        </>
                    }
                    instructionNativeAction2={
                        <>
                            <Box
                                component="img"
                                src="Step-2-img-android.png"
                                style={imageStyle}
                            ></Box>
                        </>
                    }
                    instructionNativeAction3={
                        <>
                            <Box
                                component="img"
                                src="Step-3-img-android.png"
                                style={imageStyle}
                            ></Box>
                        </>
                    }
                    instructionNotSupported={props.instructionNotSupported}
                />
            </DialogContent>
        </Dialog>
    );
};

export default InstallDialog;
